export default __webpack_public_path__ + "static/media/user.bcd1c03d.svg";